<template>
  <LoadingData v-if="isLoadingData" />
  <div v-else class="card-body">
    <form @submit.prevent="save">
      <div class="row g-3">
        <div class="col-12 col-md-6">
          <label class="form-label">
            Grupo: <span class="text-danger">*</span>
          </label>
          <select
            class="form-select"
            :class="{ 'is-invalid': v$.survey.groupId.$errors.length }"
            v-model="v$.survey.groupId.$model"
          >
            <option value="" disabled selected>Selecione um grupo</option>
            <option v-for="group in groups" :key="group.id" :value="group.id">
              {{ group.name }}
            </option>
          </select>
          <span
            v-if="v$.survey.groupId.required.$invalid"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
        </div>
        <div class="col-sm-12 col-md-6">
          <label class="form-label">
            Nome: <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': v$.survey.name.$errors.length }"
            placeholder="Identificação da Pesquisa"
            v-model="v$.survey.name.$model"
          />
          <span
            v-if="v$.survey.name.required.$invalid"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">
            Status: <span class="text-danger">*</span>
          </label>
          <select
            class="form-select"
            :class="{ 'is-invalid': v$.survey.status.$errors.length }"
            v-model="v$.survey.status.$model"
          >
            <option value="" disabled selected>Selecione uma opção</option>
            <option
              v-for="status in status"
              :key="status.id"
              :value="status.id"
            >
              {{ status.name }}
            </option>
          </select>
          <span
            v-if="v$.survey.status.required.$invalid"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">
            Idioma: <span class="text-danger">*</span>
          </label>
          <select
            class="form-select"
            :class="{ 'is-invalid': v$.survey.language.$errors.length }"
            v-model="v$.survey.language.$model"
          >
            <option value="" disabled selected>Selecione uma opção</option>
            <option
              v-for="language in languages"
              :key="language.value"
              :value="language.value"
            >
              {{ language.label }}
            </option>
          </select>
          <span
            v-if="v$.survey.language.required.$invalid"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
        </div>
        <div class="col-sm-12 col-md-6">
          <label class="form-label">Validade (em dias):</label>
          <input
            type="number"
            class="form-control"
            placeholder="Tempo em dias para responder a pesquisa"
            v-model="survey.validity"
          />
        </div>
        <div class="col-sm-12">
          <label class="form-label">
            Mensagem de Apresentação da Pesquisa:
          </label>
          <textarea
            class="form-control"
            placeholder="Mensagem de apresentação da pesquisa"
            v-model="survey.presentation"
          />
        </div>
        <div class="col-sm-12">
          <label class="form-label">
            Mensagem de Agradecimento da Pesquisa:
          </label>
          <textarea
            class="form-control"
            placeholder="Mensagem de agradecimento da pesquisa"
            v-model="survey.thanks"
          />
        </div>
        <hr class="mb-0" />
        <div class="col-sm-12">
          <label class="form-label">
            Assunto do E-mail: <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': v$.survey.emailSubject.$errors.length }"
            placeholder="Pesquisa de satisfacao - Ticket {ticket}"
            v-model="v$.survey.emailSubject.$model"
          />
          <span
            v-if="v$.survey.emailSubject.required.$invalid"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
        </div>
        <div class="col-sm-12">
          <label class="form-label">
            Apresentação do E-mail: <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': v$.survey.emailGreeting.$errors.length }"
            placeholder="Olá {nome}"
            v-model="v$.survey.emailGreeting.$model"
          />
          <span
            v-if="v$.survey.emailGreeting.required.$invalid"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
        </div>
        <div class="col-sm-12">
          <label class="form-label">Texto do E-mail:</label>
          <textarea
            class="form-control"
            placeholder="Olá {nome}, segue o link para responder a pesquisa"
            v-model="survey.emailMessage"
          />
        </div>
        <div class="col-sm-12">
          <label class="form-label">
            Pergunta do E-mail: <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': v$.survey.emailAnswer.$errors.length }"
            placeholder="Em uma escala de 0 a 10..."
            v-model="v$.survey.emailAnswer.$model"
          />
          <span
            v-if="v$.survey.emailAnswer.required.$invalid"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
        </div>
        <div class="col-12">
          <em>Palavras Dinâmicas.</em>
          <ol>
            <li>{assunto} - Assunto</li>
            <li>{nome} - Solicitante</li>
            <li>{organizacao} - Organização</li>
            <li>{email} - E-mail</li>
            <li>{ticket} - Ticket</li>
          </ol>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div>
            Criação:
            {{ createdUpdatedUser(survey.createdBy, survey.createdAt) }}
            <br />
            {{
              survey.updatedBy
                ? 'Atualização: ' +
                  createdUpdatedUser(survey.updatedBy, survey.updatedAt)
                : ''
            }}
          </div>
          <div>
            <button
              type="submit"
              class="btn btn-primary"
              title="Atualizar"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>Atualizar</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { createdUpdatedUser } from '@/utils/strings'

export default {
  name: 'EditSurvey',

  props: {
    surveyId: {
      type: String,
      required: true,
    },
  },

  components: {
    LoadingData,
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      isLoadingData: true,
      survey: {
        id: '',
        groupId: '',
        name: '',
        status: '',
        validity: '',
        presentation: '',
        language: 'pt-br',
        thanks: '',
        emailSubject: '',
        emailGreeting: '',
        emailMessage: '',
        emailAnswer: '',
        byStep: '',
        createdBy: '',
        createdAt: '',
        updatedBy: '',
        updatedAt: '',
      },
      groups: [],
      status: [
        { id: 1, name: 'Ativo' },
        { id: 0, name: 'Inativo' },
      ],
      languages: [
        {
          value: 'pt-br',
          label: 'Português (Brasil)',
        },
        {
          value: 'en',
          label: 'Inglês',
        },
      ],
      disableButton: false,
      createdUpdatedUser,
    }
  },

  methods: {
    async getSurvey() {
      try {
        this.survey = await this.$store.dispatch('getSurvey', this.surveyId)
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getGroups() {
      try {
        this.groups = await this.$store.dispatch('getGroupsActives')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          const response = await this.$store.dispatch('updateSurvey', {
            id: this.survey.id,
            survey: this.survey,
          })
          this.$root.$refs.notification.success(response.message)

          this.disableButton = false
          this.getSurvey()
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      survey: {
        groupId: {
          required,
        },
        name: {
          required,
        },
        status: {
          required,
        },
        language: {
          required,
        },
        emailSubject: {
          required,
        },
        emailGreeting: {
          required,
        },
        emailAnswer: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getSurvey()
    this.getGroups()
  },
}
</script>
